import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import BASE_URL from "config/Base_URL";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/background.jpg";

function Basic() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSignIn = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      Swal.fire({
        icon: "warning",
        title: "Login Gagal",
        text: "Username dan password harus diisi.",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      // Kirim request login ke backend
      const response = await axios.post(
        `${BASE_URL}/auth`,
        { username, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const { token, role } = response.data.data;
      // console.log(response.data.data);
      // Simpan token dan role
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("role", role);

      setUsername("");
      setPassword("");

      // Arahkan ke halaman berdasarkan role
      if (role === "ADMIN") {
        console.log("Navigating to /dashboard");
        navigate("/dashboard");
      } else if (role === "USER") {
        console.log("Navigating to /admin-dashboard");
        navigate("/admin-dashboard");
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Gagal",
          text: `Role tidak dikenali: ${role}`,
        });
      }
    } catch (error) {
      console.error("Login Gagal:", error.response?.data?.message || error.message);
      Swal.fire({
        icon: "error",
        title: "Login Gagal",
        text: error.response?.data?.message || "Terjadi kesalahan saat login",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="success"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSignIn}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Username"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="success" fullWidth>
                Sign in
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="success"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
